import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlansLoadingComponent } from './plans-loading.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    PlansLoadingComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [
    PlansLoadingComponent
  ]
})
export class PlansLoadingModule { }
